import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import Spacer from 'atoms/Spacer'
import NumberInput from 'atoms/NumberInput'
import FieldLayout from '../FieldLayout'

export default class ProposalDurationEditor extends Component {
  static propTypes = {
    proposal: PropTypes.object.isRequired,
    onProposalUpdate: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
  }

  handleSave = (duration) => {
    const { onProposalUpdate } = this.props
    onProposalUpdate({ duration })
  }

  handleDelete = () => {
    const { onDelete } = this.props
    onDelete({ duration: null })
  }

  render() {
    const { proposal } = this.props
    return (
      <Fragment>
        <Spacer />
        <FieldLayout title="Duration" onDelete={this.handleDelete}>
          <NumberInput
            required
            minValue={0}
            maxValue={360}
            valueAddon=" min"
            placeholder="Enter duration in minutes..."
            defaultValue={parseFloat(proposal.duration)}
            onSave={this.handleSave}
          />
        </FieldLayout>
      </Fragment>
    )
  }
}
